import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useMemo } from 'react';

import CellGroup1 from './CellGroup1';
import CellGroup2 from './CellGroup2';
import CellGroup3 from './CellGroup3';
import Heartbeat from './Heartbeat';
import styles from './index.module.scss';

import { Row } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import { LANDED_STATE } from '@/define/robotStatus';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  const heartbeat = useRobotTelemetry(robotId, MESSAGE.HEARTBEAT);
  const cameraFeedback = useRobotTelemetry(robotId, MESSAGE.CAMERA_FEEDBACK);
  const sysState = useRobotTelemetry(robotId, MESSAGE.EXTENDED_SYS_STATE);

  // Arm State
  const { isArm, armState } = useMemo(() => {
    const isArm = heartbeat?.isArm ?? false;
    return { isArm, armState: isArm ? 'ARM' : 'DISARM' };
  }, [heartbeat]);

  // Shoot Count
  const imageCount = useMemo(() => {
    return cameraFeedback?.imgIdx ?? 0;
  }, [cameraFeedback]);

  return (
    <div className={cx('container')}>
      <div className={cx('rows')}>
        <Row label="Heartbeat">
          <Heartbeat data={robotId} />
        </Row>
        <Row label="Arm State" value={armState} valueStyle={!isArm && { color: 'red' }} />
        <Row label="VTOL State" value={sysState?.isFixedWing ? 'Fixed-wing' : 'Multicopter'} s />
        <Row label="Landed State" value={LANDED_STATE[sysState?.landedState]} />
        {imageCount > 0 && <Row label="Shoot Count" value={commaNumber(imageCount)} />}
      </div>
      <CellGroup1 robotId={robotId} />
      <CellGroup2 robotId={robotId} />
      <CellGroup3 robotId={robotId} />
    </div>
  );
};

export default Monitor;
